const languages = {
  en: 'English',
  id: 'Indonesia',
}

module.exports = languages
